import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Button, Dialog} from '@betareader/design-system';
import {Helmet} from 'react-helmet';
import {withTranslation, Trans} from 'react-i18next';
import {push} from '../../../navigation';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {changeSubscription} from '../../../modules/subscription';
import {getUserProfile} from '../../../modules/user';

export const conversionValues = paymentSuccessData => {
  const vendor = paymentSuccessData?.checkout?.prices?.vendor;
  const parsedAmount = Number.parseFloat(vendor?.total);
  return {
    amount: Number.isFinite(parsedAmount) ? parsedAmount : 0,
    currency: typeof vendor?.currency === 'string' && /^[A-Z]{3}$/.test(vendor.currency)
      ? vendor.currency : 'USD',
  };
};

export class PaymentSuccessModal extends Component {
  close = () => {
    this.props.getUserProfile(this.props.idToken);
    this.props.onClose?.();
  };

  render() {
    const {open, paymentSuccessData, t} = this.props;
    const {amount, currency} = conversionValues(paymentSuccessData);
    return (
      <>
        <Helmet>
          <script>{`fbq('track', 'Subscribe', {value: ${amount}, currency: ${JSON.stringify(currency)}});`}</script>
          <script type='text/javascript'>{`twttr.conversion.trackPid('o1onw', {tw_sale_amount: ${amount}, tw_order_quantity: 1});`}</script>
          <script>{`gtag('event', 'conversion', {send_to: 'AW-779841759/Ff9ACKL94ZgBEN_h7fMC', value: ${amount}, currency: ${JSON.stringify(currency)}, transaction_id: ''});`}</script>
        </Helmet>
        <Dialog open={Boolean(open)} title={t('PaymentSuccess', 'Payment complete')}
          onClose={this.close}
          actions={<Button onClick={this.close}>{t('Close', 'Close')}</Button>}>
          <div style={{textAlign: 'center'}}>
            <span aria-hidden='true' style={{fontSize: '3rem', color: 'var(--br-success-text)'}}>✓</span>
            <Trans i18nKey='PaymentSuccessMessage'>
              <div>
                <h3>Thanks for your purchase!</h3>
                <p>
                  <img src='/assets/images/BR-orange-horizontal.png' alt='BetaReader'
                    style={{maxWidth: 180, width: '100%'}} />
                </p>
              </div>
            </Trans>
          </div>
        </Dialog>
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile
});

const mapDispatchToProps = dispatch => bindActionCreators({
  changeSubscription,
  getUserProfile,
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentSuccessModal)));
